























import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api';
import { SfButton, SfHeading, SfList, SfSection } from '@storefront-ui/vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { useApi } from '~/composables';
import getAllPackagesByCategoryGql from '~/modules/catalog/product/queries/getAllPackagesByCategory.gql';
import { AllAnalysisCategoriesProductsQuery, CustomCategoryTree } from '~/modules/catalog/types';
import PackageCard from '../cards/PackageCard.vue';

export default defineComponent({
  name: 'AllPackagesSection',
  components: {
    SfSection,
    SfList,
    SfHeading,
    SfButton,
    PackageCard,
    SkeletonLoader,
  },
  setup() {
    const isFetching = ref(true);
    const { query } = useApi();
    const packagesByCategory = ref<CustomCategoryTree[] | null>(null);

    const filters = {
      name: {
        match: 'Analyspaket',
      },
    };

    const fetchPackagesBaseData = async () => {
      const result = await query<AllAnalysisCategoriesProductsQuery>(getAllPackagesByCategoryGql, { filters });
      packagesByCategory.value = result.data.categories.items[0].children;
      isFetching.value = false;
    };

    useFetch(async () => {
      await fetchPackagesBaseData();
    });

    return {
      packagesByCategory,
      isFetching,
      linkToAllPackages: '/provanalyser',
      fetchPackagesBaseData,
    };
  },
});
